import { createAuthedClient } from './createAuthedClient'

export const apiClient = createAuthedClient({
  baseURL: '/api',
  storageKey: 'auth-storage',
  refreshUrl: '/api/auth/refresh',
  loginPath: '/login',
})

apiClient.interceptors.request.use((config) => {
  const tenantStored = localStorage.getItem('tenant-storage')
  if (tenantStored) {
    try {
      const { state } = JSON.parse(tenantStored) as { state: { activeTenantId?: string; activeTenantIds?: string[] } }
      // Only inject if the request did not already set an explicit tenant header
      if (state?.activeTenantId && !config.headers['X-Tenant-Id']) {
        config.headers['X-Tenant-Id'] = state.activeTenantId
      }
      if (state?.activeTenantIds?.length && !config.headers['X-Tenant-Ids']) {
        config.headers['X-Tenant-Ids'] = state.activeTenantIds.join(',')
      }
    } catch { /* ignore */ }
  }
  return config
})

export default apiClient
